<template>
  <div>
    <el-dialog
      :title="`課堂編號:${lessonNumber} - 課程名稱:${courseTitle} - Student Lists:`"
      :visible.sync="dialogStudentVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <el-table
        :data="data"
        border
        fit
        highlight-current-row
        style="width:100%;height:300px;margin-top:30px;overflow-y:scroll;"
      >
        <el-table-column align="center" label="No" width="100">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="學生編號" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.number }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="學生姓名" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'StudentDialog',
  props: {
    dialogStudentVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      lessonNumber: '',
      courseTitle: '',
      data: []
    }
  },
  methods: {
    open() {
      this.lessonNumber = this.$parent.currentStudentListLessonNumber
      this.courseTitle = this.$parent.currentStudentListCourseTitle
      this.data = this.$parent.currentStudentListData
    },
    handleClose(done) {
      this.lessonNumber = ''
      this.courseTitle = ''
      this.data = null
      this.$parent.dialogStudentVisible = false
    }
  }
}
</script>
